import Spinners from "components/Common/Spinner"
import React from "react"

import { Row } from "reactstrap"
import BlockedStepsForWp from "./blockedStepsForWp"

const PhoneVerification = ({ kycData, currentStep, querySteps = [] }) => {
  return (
    <>
      <div className="">
        <Row className="mb-2">
          <h5 className="title mb-3">Phone Verification</h5>
          <BlockedStepsForWp
            kycData={kycData}
            currentStep={currentStep}
            querySteps={querySteps}
          />
        </Row>
      </div>
    </>
  )
}

export default PhoneVerification
